import React from 'react';

import Button from 'components/Button';

import { SUBMIT_BTN_TEXT, DEFAULT_TYPE, SAVING_TEXT } from './constants';
import { SubmitButtonProps } from './types';

const SubmitButton: React.FC<SubmitButtonProps> = ({
  analyticsSource,
  analyticsText,
  invalid,
  submitting,
  ctaText,
  ...rest
}) => {
  const buttonCta = ctaText ? ctaText : SUBMIT_BTN_TEXT;
  const buttonText = submitting ? SAVING_TEXT : buttonCta;
  const page = window.location.pathname.split('/').pop()?.replace(/_/g, '-');
  const analyticsSourceName = `${analyticsSource || page}-submit-button`;

  return (
    <Button
      analyticsProperties={{
        source: analyticsSourceName,
        text: analyticsText || buttonText,
      }}
      disabled={invalid || submitting}
      type={DEFAULT_TYPE}
      {...rest}
    >
      {buttonText}
    </Button>
  );
};

export default SubmitButton;
